/* Copyright (c) 2023-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';

@Injectable()
export class NvGamepadConfig {
    /** Flag specifiying which gamepad implementation to use */
    implementationType?: 'geronimo' | 'webapi' | 'android' | 'no-op';

    /** whether to poll for gamepad connection */
    pollForGamepadConnection?: boolean;

    /** time between emitting events for continuous navigation */
    continuousNavigationInterval?: number;

    /** time for which button needs to be pressed to be considered as long press */
    longPressDuration?: number;

    /** A value specifying what percentage movement should be considered for navigation, normalized as number between 0 to 1 */
    joystickMovementThreshold?: number;

    /** Time to wait for joystick to settledown at centre before considering events for navigation*/
    cooloffDuration?: number;

    /** Polling period for the web API in default mode */
    gamepadTickPeriodDefault?: number;

    /** Polling period for the web API in lean mode */
    gamepadTickPeriodLean?: number;

    /** A value specifying what percentage movement should be considered for events, normalized as number between 0 to 1 */
    joystickTriggeredTolerance?: number;
}
